// extracted by css-extract-rspack-plugin
export default {"input":"CiV45"};